// extracted by mini-css-extract-plugin
module.exports = {"faqEn":"FAQEn_faqEn__3KzTJ","headerTitleLeft":"FAQEn_headerTitleLeft__2sjvp"};